import kanTime from "../../../src/assets/kanTime.png"
import MasMedical from "../../../src/assets/logo.png"
import Healthcare from "../../assets/Healthcare-logo.png" 
export default {
    org:{
        kanTime:{
        name:"KanTime",
        logo:kanTime,
        banner:"",
        get labels() {
        return {
          status: `${this.name} Status`,
          updated: `${this.name} Updated`,
          pending:`${this.name} Pending`,
          noAction:`${this.name} No Action`,
          default: "System",
        };
    },
    managedBy:{
       name:"Mass Medical",
       logo:MasMedical
        },
    hostedBy:{
        name:"Aukera"
    }
},
demo:{
     name:"System",
        logo:"",
        banner:"",
        get labels() {
        return {
          status: `${this.name} Status`,
          updated: `${this.name} Updated`,
          pending:`${this.name} Pending`,
          noAction:`${this.name} No Action`,
          default: "System",
        };
    },
    managedBy:{
       name:"Demo",
       logo:Healthcare,
       logoClassName:"h-16 w-auto object-contain",
       logoPadding:"pl-1 pr-6"
    },
     hostedBy:{
        name:"Demo"
    }


}
}
}


//  below change for what value given in env that should display all over the page
// type OrgConfig = {
//   name: string;
//   logo: string;
//   banner: string;
//   labels: {
//     status: string;
//     updated: string;
//     pending: string;
//     default: string;
//     [key: string]: string;
//   };
//   managedBy: {
//     name: string;
//     logo: string;
//   };
//   hostedBy: {
//     name: string;
//   };
// };
// // Utility to build labels
// const makeLabels = (orgName: string, extra?: Record<string, string>) => ({
//   status: `${orgName} Status`,
//   updated: `${orgName} Updated`,
//   pending: `${orgName} Pending`,
//   default: "System",
//   ...(extra || {}),
// });

// // Get org name from env (fallback to "Demo")
// const ORG_NAME = import.meta.env.VITE_ORG || "Demo";

// // Dynamic config
// export const demoLabels: OrgConfig = {
//   name: ORG_NAME,
//   logo: "", // you can dynamically load logos too if needed
//   banner: "",
//   labels: makeLabels(ORG_NAME, { noAction: `${ORG_NAME} No Action` }),
//   managedBy: {
//     name: `${ORG_NAME} Manager`, // dynamic managed by
//     logo: "",
//   },
//   hostedBy: {
//     name: `${ORG_NAME} Host`, // dynamic hosted by
//   },
// };